import PropTypes from 'prop-types';
import React from 'react';
import styles from './SmsMessage.less';
import _ from 'lodash';
import OrderSms from '@wix/restaurants-components-css-modules/dist/web/OrderSms/OrderSms';
import ContentConnector from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/ContentConnector';
import { isTab } from '../../../../shared/utils/A11yHelpers';
import { MODAL_A11Y_IDS } from '../../../../shared/constants';

const STATUS = {
    IDLE: 'idle',
    ERROR: 'error'
};

export default ContentConnector({prefix: 'sms_validate_'})(class extends React.Component {
    static displayName = 'SmsMessage';

    static propTypes = {
        phone: PropTypes.string.isRequired,
        countryCode: PropTypes.string,
        onSubmit: PropTypes.func.isRequired,
        onBack: PropTypes.func.isRequired,
        isCustomDesign: PropTypes.bool,
        status: PropTypes.oneOf(_.values(STATUS)).isRequired,
        onButtonBlur: PropTypes.func,
        doneButtonRef: PropTypes.func
    };

    static defaultProps = {
        onButtonBlur: () => {},
        doneButtonRef: () => {}
    };

    state = {
        isConfirming: false,
        isCorrect: true
    };

    componentWillReceiveProps(nextProps) {
        const { status } = nextProps;
        const updateState = {};

        switch (status) {
            case STATUS.IDLE:
                updateState.isCorrect = true;
                break;
            case STATUS.ERROR:
                updateState.isCorrect = false;
                break;
        }

        if (updateState.isCorrect !== this.state.isCorrect) {
            updateState.isConfirming = false;
            this.setState(updateState)
        }
    }

    render() {
        const { isCorrect, isConfirming } = this.state;
        const { phone, isCustomDesign, countryCode, onBack, content, doneButtonRef } = this.props;
        let back = content.get('back', {
            back: {
                begin: '####',
                end: '####'
            }
        }).split('####');

        back = <div>
            {back[0]}
            <strong onClick={onBack}
                    tabIndex="0"
                    role="button"
                    ref={doneButtonRef}
                    onKeyDown={this._onButtonKeyDown}>{back[1]}</strong>
            {back[2]}
        </div>;

        let stylesCopy = _.clone(styles);

        if (isCustomDesign) {
            stylesCopy.wrapper = `${stylesCopy.wrapper} ${stylesCopy.custom}`;
        }

        return (
            <OrderSms
                titleId={MODAL_A11Y_IDS.TITLE_ID}
                descriptionId={MODAL_A11Y_IDS.DESCRIPTION_ID}
                phone={phone}
                countryCode={countryCode}
                isConfirming={isConfirming}
                isCorrect={isCorrect}
                description={content.get('description')}
                backElem={back}
                onSubmit={this._onSubmit}
                styleModule={stylesCopy}/>
        );
    }

    _onSubmit = (code) => {
        const { onSubmit } = this.props;
        this.setState({isConfirming: true, isCorrect: true});
        onSubmit(code);
    };

    _goBack = () => {
        const { onBack } = this.props;
        onBack();
    };

    _onButtonKeyDown = (e) => {
        const { onButtonBlur } = this.props;
        const { tab, shiftKey } = isTab(e);

        if (tab && !shiftKey) {
            onButtonBlur(e);
            e.preventDefault();
        }
    };
});
